import { css, cx } from "@emotion/css";
import { Wallet } from "lucide-react";
import { useGetUserBalance } from "../../hooks";
import BalanceAdditionButton from "../../../../shared/components/balance-addition-button/balance-addition-button";
import type { HTMLAttributes, CSSProperties } from "react";

const wrapper = css({
  background: "var(--primary-color)",
  borderRadius: "var(--spacing-sm)",
  padding: "var(--spacing-xl)",
  boxShadow: "var(--shadow-200)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--spacing-lg)",
});

const left = css({
  display: "flex",
  alignItems: "center",
  gap: "var(--spacing-md)",
});

const iconWrap = css({
  width: 56,
  height: 56,
  minWidth: 56,
  borderRadius: "50%",
  background: "rgba(var(--pcrgba-100), .5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "var(--pc-700)",
});

const label = css({
  fontSize: "var(--fs-350)",
  color: "var(--g-600)",
});

const amount = css({
  fontSize: "clamp(1.6rem, 2.5vw, 2.2rem)",
  fontWeight: 700,
  color: "var(--g-900)",
});

const actions = css({
  display: "flex",
  alignItems: "center",
  gap: "var(--spacing-sm)",
});

const plusBtnTight = css({
  width: 36,
  height: 36,
});

export interface ProfileBalanceProps extends HTMLAttributes<HTMLDivElement> {
  style?: CSSProperties;
}

export function ProfileBalance({
  className,
  style,
  ...props
}: ProfileBalanceProps) {
  const { data } = useGetUserBalance();

  const formatted = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(data?.balance ?? 0);

  return (
    <section className={cx(wrapper, className)} style={style} {...props}>
      <div className={left}>
        <div className={iconWrap}>
          <Wallet size={28} />
        </div>
        <div>
          <div className={label}>Seu saldo</div>
          <div className={amount}>{formatted}</div>
        </div>
      </div>

      <div className={actions}>
        <BalanceAdditionButton className={plusBtnTight} />
      </div>
    </section>
  );
}

export default ProfileBalance;
